<template>
  <b-card class="app-calendar p-2">
    <FullCalendar :options="calendarOptions" class="full-calendar">
      <template v-slot:eventContent="arg">
        <template v-if="arg?.event?.extendedProps?.weekends">
          <div
            role="button"
            class="d-flex flex-column justify-content-center align-items-center text-white w-100 h-100 p-1"
          >
            <span class="text-wrap text-truncate">
              {{ arg?.event?.extendedProps?.weekends?.description }}
            </span>
          </div>
        </template>
      </template>
    </FullCalendar>
  </b-card>
</template>

<script>
import {
  BCard,
  BAvatar,
  BListGroup,
  BListGroupItem,
  BModal,
  BFormDatepicker,
  BFormTextarea,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BSpinner,
} from "bootstrap-vue";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import multiMonthPlugin from "@fullcalendar/multimonth";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import Ripple from "vue-ripple-directive";

export default {
  name: "WeekendsCalenderView",
  components: {
    BCard,
    FullCalendar,
    BAvatar,
    BListGroup,
    BListGroupItem,
    BModal,
    BFormDatepicker,
    BFormTextarea,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      calendarOptions: {},
    };
  },
  async created() {
    this.calendarOptions = {
      plugins: [multiMonthPlugin, dayGridPlugin, interactionPlugin],
      headerToolbar: {
        start: "prev,next, title",
        end: "multiMonthYear,dayGridMonth",
      },
      initialView: "multiMonthYear",
      weekends: true,
      multiMonthMaxColumns: 1,

      datesSet: async (event) => {
        const getWeekendsByYear = await this.getWeekendsByYear({
          year: new Date(event?.start).getFullYear(),
        });

        // getWeekendsByYear
        const mapWeekends = (getWeekendsByYear?.data?.data || []).map(function (
          item
        ) {
          return {
            start: item?.date,
            end: item?.date,
            allDay: true,
            display: "background",
            borderColor: "#ff9f43",
            backgroundColor: "#ff9f43",
            extendedProps: {
              weekends: {
                ...item,
              },
            },
          };
        });

        this.calendarOptions.events.push(...mapWeekends);
      },
      events: [],
      showNonCurrentDates: false,
    };
  },
  methods: {
    async getWeekendsByYear(params) {
      try {
        return await this.$api.get("api/weekends/get-by-year", {
          params: {
            year: params.year,
          },
        });
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Warning",
            icon: "BellIcon",
            variant: "warning",
            text: error?.response?.data?.message,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/apps/calendar.scss";
</style>
